import React, { useEffect } from 'react';
import { bool, node, object, string } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import eventsReporter from '../../utils/events/reporter';
import { SharedProvider } from '../../context';
import { BASE_CLASS } from './constants';

import './style.scss';

const Entry = ({
    creator,
    currency,
    businessId,
    isTouch,
    rollouts = {},
    pageName,
    eventsRoot,
    className,
    children,
}) => {
    const { userId } = getContext();

    const sourceInfo = {
        name: pageName,
        userId,
        isTouch,
    };

    const context = {
        creator,
        currency,
        businessId,
        sourceInfo,
        rollouts,
    };

    useEffect(() => {
        eventsReporter.enrich({ sourceInfo });
        eventsReporter.report(eventsRoot.pageView);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className={classNames(BASE_CLASS, className)}>
            <SharedProvider value={context}>
                <div className="entry-content">{children}</div>
            </SharedProvider>
        </section>
    );
};

Entry.propTypes = {
    creator: object,
    currency: object,
    pageName: string,
    businessId: string,
    isTouch: bool,
    rollouts: object,
    className: string,
    eventsRoot: object,
    children: node,
};

export default Entry;
